var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-popover',{attrs:{"placement":"topLeft"}},[_c('template',{slot:"content"},[_c('div',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"record"},[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }